import * as React from 'react';
import { IRiskPotReportAttachment } from '../../../models/IRiskPotReport';
import { RiskPotReportAttachmentsTable } from "./RiskPotReportAttachmentsTable";
import { RiskPotReportAttachmentsModal } from './RiskPotReportAttachmentsModal';
import { ALLMÄNTANDVÅRDBAS } from '../../../utils/RoleConstants';
import { UserContext, isInRole } from '../../../contexts/UserContext';

interface IRiskPotReportAttachments {
    attachments: IRiskPotReportAttachment[];
    getRiskPotReport: () => void;
    riskPotReportId: number;
    canBeEdited: boolean;
    changeSuccessMessage: (message: string) => void;
}

export const RiskPotReportAttachments: React.FunctionComponent<IRiskPotReportAttachments> = ({ attachments, getRiskPotReport, riskPotReportId, canBeEdited, changeSuccessMessage }) => {

    const userInfo = React.useContext(UserContext);
    const hasRoleAllmäntandvård = isInRole(ALLMÄNTANDVÅRDBAS, userInfo.roles ? userInfo.roles : []);
    const [showForm, setShowForm] = React.useState<boolean>(true);

    return (
        <div>
            <RiskPotReportAttachmentsTable attachments={attachments} setShowForm={setShowForm} canBeEdited={canBeEdited} hasRoleAllmäntandvård={hasRoleAllmäntandvård} changeSuccessMessage={changeSuccessMessage} getRiskPotReport={getRiskPotReport} />
            {
                hasRoleAllmäntandvård && canBeEdited
                    ?
                    <RiskPotReportAttachmentsModal getRiskPotReport={getRiskPotReport} riskPotReportId={riskPotReportId} showForm={showForm} setShowForm={setShowForm} />
                    : null
            }
            <hr />
        </div>
    )
}